<div class="driver-details row g-0" [ngClass]="{'driver-details--disabled': disabled}">
  <div class="col-2 col--centered">
    <img [src]="avatarUrl" class="actors--avatar" />
  </div>
  <div class="col-3 col--bold">
    <div *ngIf="name">{{ name }}</div>
    <div>
      <label>Trip:</label>
      <span>#{{ trip.id }}</span>
    </div>
    <div *ngIf="amount">
      <label>Amount:</label>
      <span>{{ amount }}</span>
    </div>
  </div>
  <div class="col-4 col--bold">
    <div *ngIf="phoneNumber" class="driver-details__phone">
      <label>
        <mat-icon [color]="disabled ? 'primary' : 'accent'">phone</mat-icon>
      </label>
      <span>{{ phoneNumber }}</span>
    </div>
    <div *ngIf="from">
      <label>From:</label>
      <span>{{ from }}</span>
    </div>
    <div *ngIf="to">
      <label>To:</label>
      <span>{{ to }}</span>
    </div>
  </div>
  <div *ngIf="status" class="col-3">
    <div class="row justify-content-center">
      <app-order-status-view [status]="status"></app-order-status-view>
    </div>
  </div>
</div>